export const PREPEND = "COOKIEDOCK";

export const DEFAULT_DATASET_NAME = "cuuid";
export const REMOVE_ELEMENT_ID = "Cookie-rde";
export const SCRIPT_ID = "#cookiedock";

export const CRYPT = "42536475697058473625364758967005846534354786970";
export const STORAGENAME = `__${PREPEND}_storage`;
export const CONTENT = `__${PREPEND}_content`;
export const REJECTED = `__${PREPEND}_rejected`;
export const COOKIE = `__${PREPEND}_cookie`;

// COOKIEDOCK:: console logs
export const TOO_MANY_SCRIPTS = `${PREPEND}:: Too many cookiedock scripts loaded`;
export const NO_CUUID_FOUND = `${PREPEND}:: No or incorrect cuuid found`;
export const WRONG_DOMAIN_ACCOUNT = `${PREPEND}:: This URL is incorrect for this account`;
export const UNABLE_TO_INSERT_HTML = `${PREPEND}:: Unable to insert dom before end of file`;
export const UNABLE_TO_INSERT_CSS = `${PREPEND}:: Unable to concat style inside the bundled file`;

// COOKIEDOCK:: main dom selectors
export const BANNER = "__cookiedock";
export const BANNER_HEADER = "--header";
export const BANNER_DESCRIPTION = "--description";
export const BANNER_PURPOSES = "--purposes";
export const BANNER_CONFIRM_BUTTON = "--confirm";
export const BANNER_SETTINGS_BUTTON = "--settings";

// COOKIEDOCK:: <dialog> dom classes
export const DIALOG = "__dialog";
export const DIALOG_SAVE_BUTTON = "--save";
export const DIALOG_CLOSE_BUTTON = "--close";

// COOKIEDOCK:: <details> dom classes
export const DETAILS = "__details";
export const DETAILS_CONTENT = "__details-content";
export const DETAILS_HEADER = "__details-header";
export const DETAILS_DESCRIPTION = "__details-description";

const PREFERENCES = "__preferences";
export const BANNER_PREFERENCES = `${PREFERENCES}--banner`;
export const DIALOG_PREFERENCES = `${PREFERENCES}--dialog`;

// Time to live
export const ONEDAY_TTL = 60 * 60 * 24;
export const ONEMONTH_TTL = ONEDAY_TTL * 30;
export const ONEYEAR_TTL = ONEDAY_TTL * 365;

export const CHECK_CHANGES_INTERVAL = 3000;
